module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "page auth-page auth-twitter-page",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": "",
      "md6": "",
      "offset-md3": "",
      "lg8": "",
      "offset-lg2": "",
      "xl8": "",
      "offset-xl2": "",
      "transition": "slide-x-reverse-transition"
    }
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('h4', [_c('span', [_vm._v(_vm._s(_vm.user.request_role))]), _vm._v(" Verification")])])], 1), _vm._v(" "), (_vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h5', [_vm._v("Personal Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.first_name),
      expression: "user.first_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "first_name",
      "autocomplete": "off",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.user.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "first_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.last_name),
      expression: "user.last_name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "last_name",
      "autocomplete": "off",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.user.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "last_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.year_of_birth_options,
      "name": "year_of_birth",
      "placeholder": "Year of Birth",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.year_of_birth),
      callback: function($$v) {
        _vm.$set(_vm.user, "year_of_birth", $$v)
      },
      expression: "user.year_of_birth"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.gender_options,
      "item-value": "value",
      "item-text": "text",
      "name": "gender",
      "placeholder": "Sex"
    },
    model: {
      value: (_vm.user.gender),
      callback: function($$v) {
        _vm.$set(_vm.user, "gender", $$v)
      },
      expression: "user.gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.country_options,
      "name": "country",
      "placeholder": "Country",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.country),
      callback: function($$v) {
        _vm.$set(_vm.user, "country", $$v)
      },
      expression: "user.country"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.city),
      expression: "user.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "city",
      "autocomplete": "off",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.user.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.user.request_role == 'artist') ? [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h5', {
    staticClass: "pt-3"
  }, [_c('span', [_vm._v("Artist")]), _vm._v(" Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.main_genres,
      "item-value": "id",
      "item-text": "name",
      "name": "main_genre",
      "placeholder": "What is your main Genre?",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.genre_id),
      callback: function($$v) {
        _vm.$set(_vm.user, "genre_id", $$v)
      },
      expression: "user.genre_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.artist_type_options,
      "name": "artist_type",
      "placeholder": "What type of artist are you?"
    },
    model: {
      value: (_vm.user.artist_type),
      callback: function($$v) {
        _vm.$set(_vm.user, "artist_type", $$v)
      },
      expression: "user.artist_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.released_albums_count_options,
      "item-value": "id",
      "item-text": "name",
      "name": "released_albums_count",
      "placeholder": "How many albums have you released?"
    },
    model: {
      value: (_vm.user.released_albums_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "released_albums_count", $$v)
      },
      expression: "user.released_albums_count"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.years_since_first_released_options,
      "item-value": "id",
      "item-text": "name",
      "name": "years_since_first_released",
      "placeholder": "How many years since your first release?"
    },
    model: {
      value: (_vm.user.years_since_first_released),
      callback: function($$v) {
        _vm.$set(_vm.user, "years_since_first_released", $$v)
      },
      expression: "user.years_since_first_released"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "will_run_live_video",
      "placeholder": "Do you plan to run live video on YouSound?"
    },
    model: {
      value: (_vm.user.will_run_live_video),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_run_live_video", $$v)
      },
      expression: "user.will_run_live_video"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "will_sell_products",
      "placeholder": "Do you sell products?"
    },
    model: {
      value: (_vm.user.will_sell_products),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_sell_products", $$v)
      },
      expression: "user.will_sell_products"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.annual_income_on_merch_sales_options,
      "item-value": "id",
      "item-text": "name",
      "name": "annual_income_on_merch_sales",
      "placeholder": "Annual income on product sales"
    },
    model: {
      value: (_vm.user.annual_income_on_merch_sales),
      callback: function($$v) {
        _vm.$set(_vm.user, "annual_income_on_merch_sales", $$v)
      },
      expression: "user.annual_income_on_merch_sales"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.annual_performances_count_options,
      "item-value": "id",
      "item-text": "name",
      "name": "annual_performances_count",
      "placeholder": "How many show do you perform annually?"
    },
    model: {
      value: (_vm.user.annual_performances_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "annual_performances_count", $$v)
      },
      expression: "user.annual_performances_count"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.signed_status_options,
      "item-value": "id",
      "item-text": "name",
      "name": "signed_status",
      "placeholder": "Are you currently signed?"
    },
    model: {
      value: (_vm.user.signed_status),
      callback: function($$v) {
        _vm.$set(_vm.user, "signed_status", $$v)
      },
      expression: "user.signed_status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.performance_rights_organization_options,
      "item-value": "id",
      "item-text": "name",
      "name": "performance_rights_organization",
      "placeholder": "Performance Rights Organization (Writers)",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.performance_rights_organization),
      callback: function($$v) {
        _vm.$set(_vm.user, "performance_rights_organization", $$v)
      },
      expression: "user.performance_rights_organization"
    }
  })], 1)] : (_vm.user.request_role == 'label') ? [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h5', {
    staticClass: "pt-3"
  }, [_c('span', [_vm._v("Label")]), _vm._v(" Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.main_genres,
      "item-value": "id",
      "item-text": "name",
      "name": "main_genre",
      "placeholder": "What is your main Genre?",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.genre_id),
      callback: function($$v) {
        _vm.$set(_vm.user, "genre_id", $$v)
      },
      expression: "user.genre_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.sub_genres,
      "item-value": "id",
      "item-text": "name",
      "name": "sub_genre",
      "placeholder": "What sub genre do you release most?",
      "autocomplete": ""
    },
    model: {
      value: (_vm.user.sub_genre_id),
      callback: function($$v) {
        _vm.$set(_vm.user, "sub_genre_id", $$v)
      },
      expression: "user.sub_genre_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.released_albums_count_options,
      "item-value": "id",
      "item-text": "name",
      "name": "released_albums_count",
      "placeholder": "How many albums have you released?"
    },
    model: {
      value: (_vm.user.released_albums_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "released_albums_count", $$v)
      },
      expression: "user.released_albums_count"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.years_since_first_released_options,
      "item-value": "id",
      "item-text": "name",
      "name": "years_since_first_released",
      "placeholder": "How many years since your first release?"
    },
    model: {
      value: (_vm.user.years_since_first_released),
      callback: function($$v) {
        _vm.$set(_vm.user, "years_since_first_released", $$v)
      },
      expression: "user.years_since_first_released"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "will_run_live_video",
      "placeholder": "Do you plan to run live video on YouSound?"
    },
    model: {
      value: (_vm.user.will_run_live_video),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_run_live_video", $$v)
      },
      expression: "user.will_run_live_video"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "will_sell_products",
      "placeholder": "Do you sell products?"
    },
    model: {
      value: (_vm.user.will_sell_products),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_sell_products", $$v)
      },
      expression: "user.will_sell_products"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.annual_income_on_merch_sales_options,
      "item-value": "id",
      "item-text": "name",
      "name": "annual_income_on_merch_sales",
      "placeholder": "Annual income on product sales"
    },
    model: {
      value: (_vm.user.annual_income_on_merch_sales),
      callback: function($$v) {
        _vm.$set(_vm.user, "annual_income_on_merch_sales", $$v)
      },
      expression: "user.annual_income_on_merch_sales"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "is_business_registered",
      "placeholder": "Is your business registered?"
    },
    model: {
      value: (_vm.user.is_business_registered),
      callback: function($$v) {
        _vm.$set(_vm.user, "is_business_registered", $$v)
      },
      expression: "user.is_business_registered"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    attrs: {
      "items": _vm.artists_count_options,
      "item-value": "id",
      "item-text": "name",
      "name": "artists_count",
      "placeholder": "How many artists are currently on your roster?"
    },
    model: {
      value: (_vm.user.artists_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "artists_count", $$v)
      },
      expression: "user.artists_count"
    }
  })], 1)] : (_vm.user.request_role == 'brand') ? [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h5', {
    staticClass: "pt-3"
  }, [_c('span', [_vm._v("Brand")]), _vm._v(" Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.standard_brand_type_options,
      "name": "standard_brand_type",
      "placeholder": "What type of Brand?"
    },
    model: {
      value: (_vm.user.standard_brand_type),
      callback: function($$v) {
        _vm.$set(_vm.user, "standard_brand_type", $$v)
      },
      expression: "user.standard_brand_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.customized_brand_type),
      expression: "user.customized_brand_type"
    }],
    attrs: {
      "type": "text",
      "name": "customized_brand_type",
      "autocomplete": "off",
      "placeholder": "If your Brand type isn't listed what kind of brand are you?"
    },
    domProps: {
      "value": (_vm.user.customized_brand_type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "customized_brand_type", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.employees_count_options,
      "item-value": "id",
      "item-text": "name",
      "name": "employees_count",
      "placeholder": "How many employees do you have?"
    },
    model: {
      value: (_vm.user.employees_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "employees_count", $$v)
      },
      expression: "user.employees_count"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.years_in_business_options,
      "item-value": "id",
      "item-text": "name",
      "name": "years_in_business",
      "placeholder": "How many years in business?"
    },
    model: {
      value: (_vm.user.years_in_business),
      callback: function($$v) {
        _vm.$set(_vm.user, "years_in_business", $$v)
      },
      expression: "user.years_in_business"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "will_sell_music_related_products",
      "placeholder": "Do you sell music related products or services?"
    },
    model: {
      value: (_vm.user.will_sell_music_related_products),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_sell_music_related_products", $$v)
      },
      expression: "user.will_sell_music_related_products"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "will_run_live_video",
      "placeholder": "Do you plan to run live video on YouSound?"
    },
    model: {
      value: (_vm.user.will_run_live_video),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_run_live_video", $$v)
      },
      expression: "user.will_run_live_video"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "will_sell_products",
      "placeholder": "Do you sell products?"
    },
    model: {
      value: (_vm.user.will_sell_products),
      callback: function($$v) {
        _vm.$set(_vm.user, "will_sell_products", $$v)
      },
      expression: "user.will_sell_products"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.products_count_options,
      "item-value": "id",
      "item-text": "name",
      "name": "products_count",
      "placeholder": "How many products / SKUs do you have?"
    },
    model: {
      value: (_vm.user.products_count),
      callback: function($$v) {
        _vm.$set(_vm.user, "products_count", $$v)
      },
      expression: "user.products_count"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.annual_income_options,
      "item-value": "id",
      "item-text": "name",
      "name": "annual_income",
      "placeholder": "Annual income"
    },
    model: {
      value: (_vm.user.annual_income),
      callback: function($$v) {
        _vm.$set(_vm.user, "annual_income", $$v)
      },
      expression: "user.annual_income"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.boolean_options,
      "item-value": "id",
      "item-text": "name",
      "name": "is_business_registered",
      "placeholder": "Is your business registered?"
    },
    model: {
      value: (_vm.user.is_business_registered),
      callback: function($$v) {
        _vm.$set(_vm.user, "is_business_registered", $$v)
      },
      expression: "user.is_business_registered"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.website_1_url),
      expression: "user.website_1_url"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:1023|url'),
      expression: "'required|max:1023|url'"
    }],
    attrs: {
      "type": "text",
      "name": "website_1_url",
      "autocomplete": "off",
      "placeholder": "Website URL"
    },
    domProps: {
      "value": (_vm.user.website_1_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "website_1_url", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.website_2_url),
      expression: "user.website_2_url"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:1023|url'),
      expression: "'max:1023|url'"
    }],
    attrs: {
      "type": "text",
      "name": "website_2_url",
      "autocomplete": "off",
      "placeholder": "Website URL"
    },
    domProps: {
      "value": (_vm.user.website_2_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "website_2_url", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-3": "",
      "px-2": "",
      "text-xs-center": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.history),
      expression: "user.history"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:1023'),
      expression: "'required|max:1023'"
    }],
    attrs: {
      "name": "history",
      "placeholder": "What artists and/or labels have you previously worked with?"
    },
    domProps: {
      "value": (_vm.user.history)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "history", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('p', [_vm._v("\n              All of the information you share with us is secure, never sold & used to verify users."), _c('br'), _vm._v("\n              You agree to our terms of services by signing up.\n              "), _c('router-link', {
    staticClass: "forgot-password",
    attrs: {
      "to": "/terms",
      "target": "_blank"
    }
  }, [_vm._v("View our terms.")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "reset-btn",
    attrs: {
      "block": "",
      "round": "",
      "dark": "",
      "type": "submit"
    }
  }, [_vm._v("Next")])], 1)], 2)], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69e8c1fd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/twitter_callback.vue
// module id = 1759
// module chunks = 180